var map = {
	"./components/BaseModal.vue": 3344,
	"./components/DeleteButton.vue": 7488,
	"./components/DeleteModal.vue": 7036,
	"./components/ExampleComponent.vue": 2043,
	"./components/GraficoAbandonoescolar.vue": 4133,
	"./components/GraficoAccesointernet.vue": 9066,
	"./components/GraficoDiscapacidad.vue": 2362,
	"./components/GraficoIdiomas.vue": 1590,
	"./components/GraficoLaboral.vue": 9739,
	"./components/GraficoMediotransporte.vue": 9514,
	"./components/GraficoSeguro.vue": 2007,
	"./components/GraficoServiciosbasicos.vue": 7637,
	"./components/GraficoSexo.vue": 5438,
	"./components/GraficoTiempotransporte.vue": 3404,
	"./components/GraficoVivecon.vue": 1992
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5642;